import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dayhours' })
export class DayhoursPipe implements PipeTransform {

    transform(value: any, zeroStr = '0ч', errStr = '', space = ' '): any {
        if (value === undefined || value === null || isNaN(value)) {
            return errStr;
        }
        value = +value;
        if (value === 0) {
            return zeroStr;
        }
        const d = Math.trunc(value / 24);
        const h = value % 24;
        return (d ? d + 'д' + space : '') + (h ? (h % 1 ? h.toFixed(1) : h) + 'ч' : '');
    }

}
